export const translations = {
  ru: {
    nav: {
      about: 'О нас',
      services: 'Услуги',
      founder: 'Основатель',
      team: 'Команда',
      contact: 'Контакты',
    },
    header: {
      contactButton: 'Связаться с нами',
    },
    hero: {
      subtitle: 'International Association of Independent Developers',
      title1: 'Neural Brain',
      title2: 'Team',
      description1: 'Технологии как инструмент свободы, а не контроля.',
      description2: 'Мы говорим результатами, а не заявлениями.',
    },
    about: {
      label: 'О нас',
      title: 'Международное объединение свободных разработчиков',
      p1: 'Neural Brain Team — международное объединение свободных разработчиков, основанное Андреем Голденбергом в 2018 году.',
      p2: 'Мы создаём технологии как инструмент свободы, а не контроля. Наша философия — инженерная зрелость, глубина и ответственность.',
      p3: 'Мы не публичная команда. Мы сознательно держимся в стороне от инфошума и хайпа.',
      p4: 'Мы предпочитаем говорить результатами, а не заявлениями.',
    },
    services: {
      label: 'Чем мы занимаемся',
      title: 'Наши компетенции',
      items: [
        {
          title: 'IT-безопасность',
          description: 'Защита инфраструктуры и данных. Архитектура, аудит, инженерная дисциплина.',
        },
        {
          title: 'AI-продукты для бизнеса',
          description: 'Разработка и внедрение интеллектуальных систем. Практичный подход, реальные задачи.',
        },
        {
          title: 'Мобильная разработка',
          description: 'Приложения любой сложности: от MVP до экосистем. Чистая архитектура, UX, поддержка.',
        },
        {
          title: 'Маркетинг',
          description: 'Стратегия, аналитика, позиционирование. Превращение технологий в живые продукты.',
        },
      ],
    },
    founder: {
      label: 'Основатель',
      name: 'Андрей Голденберг',
      role: 'Основатель и руководитель Neural Brain Team.',
      competenciesTitle: 'Ключевые компетенции:',
      competencies: [
        'Разработка систем искусственного интеллекта',
        'Интеграция AI в бизнес',
        'Нейролингвистическое программирование личности',
        'IT-безопасность',
      ],
      projectsTitle: 'Социальные проекты:',
      projects: [
        '«Дневник счастливого отца»',
        'Сообщество «Люди Космоса»',
      ],
    },
    team: {
      label: 'Команда',
      title: 'Международное объединение',
      description: 'Специалисты из разных стран, объединённые общими ценностями: инженерия, свобода, ответственность.',
      shadowNote: 'Предпочитает оставаться в тени',
      closingText: 'Около сорока специалистов работают с нами подпроектно. Они предпочитают оставаться вне публичного пространства, и мы полностью уважаем этот выбор. Свобода — ключевой принцип нашей команды, и каждый участник сам определяет степень своей видимости.',
      roles: {
        founder: 'Основатель и руководитель',
        cofounder: 'Сооснователь',
        productManager: 'Product Manager',
        communicationsDirector: 'Директор по коммуникациям',
        leadDeveloper: 'Главный разработчик',
        teamLead: 'Team Lead',
        marketingHead: 'Глава отдела маркетинга',
        seniorDev: 'Senior Developer',
        securitySpecialist: 'Security Specialist',
        aiEngineer: 'AI Engineer',
      },
      bios: {
        kirillGoman: 'Кирилл Гоман — точный и методичный руководитель, обладающий редким умением держать процессы в идеальном порядке. Он — тот, кто всегда ясно понимает, что нужно команде, и создаёт условия, в которых каждый специалист работает уверенно и результативно. Структурное мышление, дисциплина и безупречное чувство ответственности делают его опорой в сложных проектах и надёжным линейным лидером.',
        daniilShamraev: 'Даниил Шамраев — автор протокола безопасности Byte Lock и один из самых сильных инженеров Neural Brain Team. Он — специалист, способный писать код любой сложности, но его ценность выходит далеко за рамки техники. Даниил не просто программирует — он видит мир в коде, воспринимая архитектуру, логику и безопасность как единую живую систему. Его решения точны, глубоки и всегда на шаг впереди возможных рисков.',
        andreyMoiseev: 'Андрей Моисеев — мастер переговоров и человек, который способен договориться с кем угодно, о чём угодно и в любой точке мира. Его сила — в глубоком понимании людей, точной коммуникации и умении находить решения там, где другие видят тупик. Специалист в области коммуникаций, психологии и NLP, он превращает сложные диалоги в управляемые процессы и создаёт пространство, где интересы сторон сходятся естественно и без давления.',
        albertKhilazhev: 'Альберт Хилажев — не просто маркетолог, а специалист, который умеет создавать тренды и формировать потребности ещё до того, как рынок осознаёт их существование. Он тонко чувствует динамику аудитории, видит закономерности там, где другие видят хаос, и превращает идеи в устойчивый интерес. Его подход сочетает стратегическое мышление, аналитическую точность и редкое интуитивное понимание того, что станет востребованным завтра.',
      },
    },
    contact: {
      label: 'Связь',
      title: 'Связаться с нами',
      namePlaceholder: 'Ваше имя',
      emailPlaceholder: 'Email',
      messagePlaceholder: 'Ваше сообщение',
      submitButton: 'Отправить',
      submitting: 'Отправляется...',
      successMessage: 'Сообщение успешно отправлено!',
      errorMessage: 'Ошибка при отправке. Попробуйте ещё раз.',
      validationError: 'Пожалуйста, заполните все поля',
    },
    footer: {
      copyright: 'Все права защищены.',
      tagline: 'Technology as freedom',
    },
  },
  en: {
    nav: {
      about: 'About',
      services: 'Services',
      founder: 'Founder',
      team: 'Team',
      contact: 'Contact',
    },
    header: {
      contactButton: 'Contact Us',
    },
    hero: {
      subtitle: 'International Association of Independent Developers',
      title1: 'Neural Brain',
      title2: 'Team',
      description1: 'Technology as a tool for freedom, not control.',
      description2: 'We speak with results, not statements.',
    },
    about: {
      label: 'About Us',
      title: 'International Association of Independent Developers',
      p1: 'Neural Brain Team is an international association of independent developers founded by Andrey Goldenberg in 2018.',
      p2: 'We create technology as a tool for freedom, not control. Our philosophy is engineering maturity, depth, and responsibility.',
      p3: 'We are not a public team. We consciously stay away from information noise and hype.',
      p4: 'We prefer to speak with results, not statements.',
    },
    services: {
      label: 'What We Do',
      title: 'Our Competencies',
      items: [
        {
          title: 'IT Security',
          description: 'Infrastructure and data protection. Architecture, audit, engineering discipline.',
        },
        {
          title: 'AI Products for Business',
          description: 'Development and implementation of intelligent systems. Practical approach, real tasks.',
        },
        {
          title: 'Mobile Development',
          description: 'Applications of any complexity: from MVP to ecosystems. Clean architecture, UX, support.',
        },
        {
          title: 'Marketing',
          description: 'Strategy, analytics, positioning. Turning technology into living products.',
        },
      ],
    },
    founder: {
      label: 'Founder',
      name: 'Andrey Goldenberg',
      role: 'Founder and CEO of Neural Brain Team.',
      competenciesTitle: 'Key Competencies:',
      competencies: [
        'Development of artificial intelligence systems',
        'AI integration in business',
        'Neuro-linguistic personality programming',
        'IT security',
      ],
      projectsTitle: 'Social Projects:',
      projects: [
        '"Diary of a Happy Father"',
        '"People of Cosmos" Community',
      ],
    },
    team: {
      label: 'Team',
      title: 'International Association',
      description: 'Specialists from different countries united by common values: engineering, freedom, responsibility.',
      shadowNote: 'Prefers to stay in the shadows',
      roles: {
        founder: 'Founder and CEO',
        cofounder: 'Co-founder',
        productManager: 'Product Manager',
        communicationsDirector: 'Communications Director',
        leadDeveloper: 'Lead Developer',
        teamLead: 'Team Lead',
        marketingHead: 'Head of Marketing',
        seniorDev: 'Senior Developer',
        securitySpecialist: 'Security Specialist',
        aiEngineer: 'AI Engineer',
      },
    },
    contact: {
      label: 'Contact',
      title: 'Contact Us',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'Email',
      messagePlaceholder: 'Your message',
      submitButton: 'Send',
      submitting: 'Sending...',
      successMessage: 'Message sent successfully!',
      errorMessage: 'Error sending message. Please try again.',
      validationError: 'Please fill in all fields',
    },
    footer: {
      copyright: 'All rights reserved.',
      tagline: 'Technology as freedom',
    },
  },
  es: {
    nav: {
      about: 'Nosotros',
      services: 'Servicios',
      founder: 'Fundador',
      team: 'Equipo',
      contact: 'Contacto',
    },
    header: {
      contactButton: 'Contáctenos',
    },
    hero: {
      subtitle: 'Asociación Internacional de Desarrolladores Independientes',
      title1: 'Neural Brain',
      title2: 'Team',
      description1: 'La tecnología como herramienta de libertad, no de control.',
      description2: 'Hablamos con resultados, no con declaraciones.',
    },
    about: {
      label: 'Nosotros',
      title: 'Asociación Internacional de Desarrolladores Independientes',
      p1: 'Neural Brain Team es una asociación internacional de desarrolladores independientes fundada por Andrey Goldenberg en 2018.',
      p2: 'Creamos tecnología como herramienta de libertad, no de control. Nuestra filosofía es madurez ingenieril, profundidad y responsabilidad.',
      p3: 'No somos un equipo público. Conscientemente nos mantenemos alejados del ruido informativo y el bombo.',
      p4: 'Preferimos hablar con resultados, no con declaraciones.',
    },
    services: {
      label: 'Qué Hacemos',
      title: 'Nuestras Competencias',
      items: [
        {
          title: 'Seguridad IT',
          description: 'Protección de infraestructura y datos. Arquitectura, auditoría, disciplina ingenieril.',
        },
        {
          title: 'Productos AI para Negocios',
          description: 'Desarrollo e implementación de sistemas inteligentes. Enfoque práctico, tareas reales.',
        },
        {
          title: 'Desarrollo Móvil',
          description: 'Aplicaciones de cualquier complejidad: desde MVP hasta ecosistemas. Arquitectura limpia, UX, soporte.',
        },
        {
          title: 'Marketing',
          description: 'Estrategia, análisis, posicionamiento. Convertir tecnología en productos vivos.',
        },
      ],
    },
    founder: {
      label: 'Fundador',
      name: 'Andrey Goldenberg',
      role: 'Fundador y CEO de Neural Brain Team.',
      competenciesTitle: 'Competencias Clave:',
      competencies: [
        'Desarrollo de sistemas de inteligencia artificial',
        'Integración de IA en negocios',
        'Programación neurolingüística de personalidad',
        'Seguridad IT',
      ],
      projectsTitle: 'Proyectos Sociales:',
      projects: [
        '"Diario de un Padre Feliz"',
        'Comunidad "Gente del Cosmos"',
      ],
    },
    team: {
      label: 'Equipo',
      title: 'Asociación Internacional',
      description: 'Especialistas de diferentes países unidos por valores comunes: ingeniería, libertad, responsabilidad.',
      shadowNote: 'Prefiere permanecer en las sombras',
      roles: {
        founder: 'Fundador y CEO',
        cofounder: 'Cofundador',
        productManager: 'Gerente de Producto',
        communicationsDirector: 'Director de Comunicaciones',
        leadDeveloper: 'Desarrollador Principal',
        teamLead: 'Líder de Equipo',
        marketingHead: 'Jefe de Marketing',
        seniorDev: 'Desarrollador Senior',
        securitySpecialist: 'Especialista en Seguridad',
        aiEngineer: 'Ingeniero de IA',
      },
    },
    contact: {
      label: 'Contacto',
      title: 'Contáctenos',
      namePlaceholder: 'Su nombre',
      emailPlaceholder: 'Email',
      messagePlaceholder: 'Su mensaje',
      submitButton: 'Enviar',
      submitting: 'Enviando...',
      successMessage: '¡Mensaje enviado con éxito!',
      errorMessage: 'Error al enviar. Inténtelo de nuevo.',
      validationError: 'Por favor complete todos los campos',
    },
    footer: {
      copyright: 'Todos los derechos reservados.',
      tagline: 'Tecnología como libertad',
    },
  },
  zh: {
    nav: {
      about: '关于我们',
      services: '服务',
      founder: '创始人',
      team: '团队',
      contact: '联系方式',
    },
    header: {
      contactButton: '联系我们',
    },
    hero: {
      subtitle: '国际独立开发者协会',
      title1: 'Neural Brain',
      title2: 'Team',
      description1: '技术是自由的工具，而非控制的手段。',
      description2: '我们用结果说话，而非空谈。',
    },
    about: {
      label: '关于我们',
      title: '国际独立开发者协会',
      p1: 'Neural Brain Team是由安德烈·戈尔登伯格于2018年创立的国际独立开发者协会。',
      p2: '我们创造技术作为自由的工具，而非控制。我们的理念是工程成熟度、深度和责任。',
      p3: '我们不是一个公开的团队。我们有意远离信息噪音和炒作。',
      p4: '我们更愿意用结果说话，而非空谈。',
    },
    services: {
      label: '我们的服务',
      title: '我们的能力',
      items: [
        {
          title: 'IT安全',
          description: '基础设施和数据保护。架构、审计、工程规范。',
        },
        {
          title: '商业AI产品',
          description: '智能系统的开发和实施。实用方法，真实任务。',
        },
        {
          title: '移动开发',
          description: '任何复杂度的应用：从MVP到生态系统。清晰架构、用户体验、支持。',
        },
        {
          title: '营销',
          description: '战略、分析、定位。将技术转化为活的产品。',
        },
      ],
    },
    founder: {
      label: '创始人',
      name: '安德烈·戈尔登伯格',
      role: 'Neural Brain Team创始人兼CEO。',
      competenciesTitle: '核心能力：',
      competencies: [
        '人工智能系统开发',
        'AI商业整合',
        '神经语言人格编程',
        'IT安全',
      ],
      projectsTitle: '社会项目：',
      projects: [
        '《快乐父亲日记》',
        '《宇宙之人》社区',
      ],
    },
    team: {
      label: '团队',
      title: '国际协会',
      description: '来自不同国家的专家，以共同价值观团结：工程、自由、责任。',
      shadowNote: '更愿意保持低调',
      roles: {
        founder: '创始人兼CEO',
        cofounder: '联合创始人',
        productManager: '产品经理',
        communicationsDirector: '传播总监',
        leadDeveloper: '首席开发',
        teamLead: '团队负责人',
        marketingHead: '营销主管',
        seniorDev: '高级开发',
        securitySpecialist: '安全专家',
        aiEngineer: 'AI工程师',
      },
    },
    contact: {
      label: '联系',
      title: '联系我们',
      namePlaceholder: '您的姓名',
      emailPlaceholder: '邮箱',
      messagePlaceholder: '您的留言',
      submitButton: '发送',
      submitting: '发送中...',
      successMessage: '消息发送成功！',
      errorMessage: '发送错误。请重试。',
      validationError: '请填写所有字段',
    },
    footer: {
      copyright: '保留所有权利。',
      tagline: '技术即自由',
    },
  },
  fr: {
    nav: {
      about: 'À propos',
      services: 'Services',
      founder: 'Fondateur',
      team: 'Équipe',
      contact: 'Contact',
    },
    header: {
      contactButton: 'Nous contacter',
    },
    hero: {
      subtitle: 'Association Internationale de Développeurs Indépendants',
      title1: 'Neural Brain',
      title2: 'Team',
      description1: 'La technologie comme outil de liberté, pas de contrôle.',
      description2: 'Nous parlons avec des résultats, pas des déclarations.',
    },
    about: {
      label: 'À propos',
      title: 'Association Internationale de Développeurs Indépendants',
      p1: 'Neural Brain Team est une association internationale de développeurs indépendants fondée par Andrey Goldenberg en 2018.',
      p2: 'Nous créons la technologie comme outil de liberté, pas de contrôle. Notre philosophie est la maturité technique, la profondeur et la responsabilité.',
      p3: 'Nous ne sommes pas une équipe publique. Nous restons consciemment à l\'écart du bruit informationnel et du battage médiatique.',
      p4: 'Nous préférons parler avec des résultats, pas des déclarations.',
    },
    services: {
      label: 'Ce que nous faisons',
      title: 'Nos Compétences',
      items: [
        {
          title: 'Sécurité IT',
          description: 'Protection des infrastructures et des données. Architecture, audit, discipline technique.',
        },
        {
          title: 'Produits IA pour Entreprises',
          description: 'Développement et mise en œuvre de systèmes intelligents. Approche pratique, tâches réelles.',
        },
        {
          title: 'Développement Mobile',
          description: 'Applications de toute complexité : du MVP aux écosystèmes. Architecture propre, UX, support.',
        },
        {
          title: 'Marketing',
          description: 'Stratégie, analyse, positionnement. Transformer la technologie en produits vivants.',
        },
      ],
    },
    founder: {
      label: 'Fondateur',
      name: 'Andrey Goldenberg',
      role: 'Fondateur et PDG de Neural Brain Team.',
      competenciesTitle: 'Compétences Clés :',
      competencies: [
        'Développement de systèmes d\'intelligence artificielle',
        'Intégration de l\'IA dans les affaires',
        'Programmation neuro-linguistique de la personnalité',
        'Sécurité IT',
      ],
      projectsTitle: 'Projets Sociaux :',
      projects: [
        '« Journal d\'un Père Heureux »',
        'Communauté « Gens du Cosmos »',
      ],
    },
    team: {
      label: 'Équipe',
      title: 'Association Internationale',
      description: 'Spécialistes de différents pays unis par des valeurs communes : ingénierie, liberté, responsabilité.',
      shadowNote: 'Préfère rester dans l\'ombre',
      roles: {
        founder: 'Fondateur et PDG',
        cofounder: 'Co-fondateur',
        productManager: 'Chef de Produit',
        communicationsDirector: 'Directeur des Communications',
        leadDeveloper: 'Développeur Principal',
        teamLead: 'Chef d\'Équipe',
        marketingHead: 'Directeur Marketing',
        seniorDev: 'Développeur Senior',
        securitySpecialist: 'Spécialiste Sécurité',
        aiEngineer: 'Ingénieur IA',
      },
    },
    contact: {
      label: 'Contact',
      title: 'Nous contacter',
      namePlaceholder: 'Votre nom',
      emailPlaceholder: 'Email',
      messagePlaceholder: 'Votre message',
      submitButton: 'Envoyer',
      submitting: 'Envoi...',
      successMessage: 'Message envoyé avec succès !',
      errorMessage: 'Erreur d\'envoi. Veuillez réessayer.',
      validationError: 'Veuillez remplir tous les champs',
    },
    footer: {
      copyright: 'Tous droits réservés.',
      tagline: 'Technologie comme liberté',
    },
  },
};
